module.exports = __webpack_public_path__ + "img/chevron-pink.bae02f71.svg";